import { Constants } from "appConstants";

const ErrorHelper = {
	getObjMessageAsArray(obj: any) {
		if (typeof obj === "string") {
			return [obj];
		}
		return Object.keys(obj).map((key) => {
			let message = obj[key];
			if (typeof message === "object") {
				message =
					message instanceof Array
						? message
								.map((msgItem) =>
									typeof msgItem?.message === "string"
										? msgItem?.message
										: this.getObjMessageAsArray(msgItem)
								)
								.join(", ")
						: ErrorHelper.getObjMessageAsArray(message);
			}
			return message;
		});
	},

	getErrorMessage(error: any) {
		const { response } = error;
		const defaultError = Constants.strings.errors.somethingWentWrong;

		try {
			if (response?.status === 0 || error?.code === "ERR_NETWORK") {
				return Constants.strings.errors.conectionError;
			}
			if (response?.status === 502) {
				return Constants.strings.errors.conectionFailed;
			}
			if (response?.data) {
				if (typeof response.data === "string" && response.data !== "None") {
					return response.data;
				}

				if (typeof response.data === "object") {
					const dataToParse = response.data?.errors || response.data;
					const parsed =
						dataToParse instanceof Array
							? dataToParse
							: ErrorHelper.getObjMessageAsArray(dataToParse);
					return parsed.join("\n").replace("non_field_errors: ", "");
				}
			}
			return defaultError;
		} catch {
			return defaultError;
		}
	}
};

export default ErrorHelper;
